/*
 * Copyright (c) 2025, Ramble Ventures
 */

export const SettingsForm = function (props) {
    return (
        <form method="post">
            {props.children}
        </form>
    )
}
